import { render, staticRenderFns } from "./ECommerceOrderCompleated.vue?vue&type=template&id=71464418&scoped=true&"
import script from "./ECommerceOrderCompleated.vue?vue&type=script&lang=js&"
export * from "./ECommerceOrderCompleated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71464418",
  null
  
)

export default component.exports